// Opens the Unicorn cart drawer, waiting briefly if the app script hasn't loaded yet.
// Resolves false when Unicorn isn't available so callers can fall back.
window.ssOpenCart = function () {
  const openUnicorn = async () => {
    if (typeof window.unicornRefreshCart === 'function') { try { await window.unicornRefreshCart(); } catch (e) { /* ignore */ } }
    window.unicornOpenCart();
    return true;
  };
  if (typeof window.unicornOpenCart === 'function') return openUnicorn();
  return new Promise((resolve) => {
    let waited = 0;
    const timer = setInterval(() => {
      waited += 200;
      if (typeof window.unicornOpenCart === 'function') { clearInterval(timer); resolve(openUnicorn()); }
      else if (waited >= 5000) { clearInterval(timer); resolve(false); }
    }, 200);
  });
};

class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  // The store uses the Unicorn Boost cart drawer, so every theme path that opens the mini cart
  // (quick add, swatches, mobile dock, bundles) is sent there. The theme drawer is only a fallback.
  open() {
    window.ssOpenCart().then((opened) => { if (!opened) this.openNative(); });
  }

  openNative() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
